import {SET_SEARCHING, SET_ERROR, SET_SAVING, SET_SUPPLEMENT, SET_REBATE, SET_REFUND} from '@/constants/mutation_types'
import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    items: {
      transactionList: null
    },
    calculate: false,
    searching: false,
    supplement: false,
    rebate: false,
    refund: false,
    saving: false,
    errors: []
  },
  getters: {

  },
  mutations: {
    [SET_SEARCHING] (state, searching) {
      state.searching = searching
    },
    [SET_ERROR] (state, errors) {
      state.errors = state.errors.concat(errors)
    },
    [SET_SAVING] (state, saving) {
      state.saving = saving
    },
    [SET_SUPPLEMENT] (state, supplement) {
      state.supplement = supplement
    },
    [SET_REBATE] (state, rebate) {
      state.rebate = rebate
    },
    [SET_REFUND] (state, refund) {
      state.refund = refund
    },
    setTransactionList (state, list) {
      // state.items.transactionList = list
      Vue.set(state.items, 'transactionList', list)
    }
  },
  actions: {
    setSaving ({ commit }, saving) {
      commit('SET_SAVING', saving)
    },
    setSearching ({ commit }, searchingForm) {
      // console.log(searching)
      // console.log(searchingForm)
      commit('SET_SEARCHING', searchingForm)
      // return searchingForm
    },
    setSupplement ({ commit }, supplement) {
      commit('SET_SUPPLEMENT', supplement)
      // return searchingForm
    },
    setRefund ({ commit }, refund) {
      commit('SET_REFUND', refund)
    },
    setRebate ({ commit }, rebate) {
      commit('SET_REBATE', rebate)
    },
    setError ({ commit }, errors) {
      commit('SET_ERROR', errors)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/transaction.js